import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {CommonModule} from "@angular/common";
import {WellSystemSettingsFacade} from "../+state/well-system-settings.facade";
import { ToggleSwitch } from 'primeng/toggleswitch';
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {Observable} from "rxjs";

@Component({
  selector: 'well-system-settings',
  templateUrl: './well-system-settings.component.html',
  styleUrls: ['./well-system-settings.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ToggleSwitch,
    FormsModule,
    TranslateModule
  , ToggleSwitch]
})
export class WellSystemSettingsComponent {

  systemSettingsFacade = inject(WellSystemSettingsFacade);

  numberOfDaysOffset$: Observable<number | undefined> = this.systemSettingsFacade.getSetting('numberOfDaysForCalendarOffset');

  numberOfDaysOffsetChanged(currentState: number) {
    if(currentState === 2) {
      this.systemSettingsFacade.updateNumberOfDaysForCalendarOffset(365);
      return;
    }
    this.systemSettingsFacade.updateNumberOfDaysForCalendarOffset(2);
  }
}
